<template>
  <a href="#" class="option" @click.prevent.stop="onClick">
    <div class="icon" v-if="icon">
      <font-awesome-icon :icon="icon" />
    </div>
    <div class="label" v-if="label">{{ label }}</div>
    <div class="arrow" v-if="isExpandable">
      <font-awesome-icon :icon="['fas', isOpen ? 'chevron-down' : 'chevron-right']" />
    </div>
  </a>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'navigation-option',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: Array,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    isExpandable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onClick() {
      this.isOpen = !this.isOpen // Toggle the value
    }
  }
})
</script>

<style scoped>
.option {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 6px;
  &:hover {
    background-color: var(--blue-light);
  }
  .icon {
    margin-right: 0.5rem;
    font-size: 1.25rem;
  }
  .label {
    font-weight: 500;
  }
  .arrow {
    width: 14px;
    height: 14px;
    margin-left: 0.5rem;
    font-size: 0.875rem;
    color: var(--grey);
  }
}
</style>
